import { nanoid } from 'nanoid'
import { useEditor } from '@/state/store'
import { formatFeetInches } from '@/lib/units'
import { ordinalFloorName } from '@/model/defaults'
import { bounds } from '@/lib/geometry'
import { rectPath } from '@/lib/geometry'

/** Floor list / switcher. Single-floor for v1, but built to stack levels. */
export function LevelPanel() {
  const levels = useEditor((s) => s.project.levels)
  const activeLevelId = useEditor((s) => s.activeLevelId)
  const setActiveLevel = useEditor((s) => s.setActiveLevel)
  const update = useEditor((s) => s.update)
  const duplicateFloor = useEditor((s) => s.duplicateFloor)
  const floorHeight = useEditor((s) => s.project.settings.standards.floorHeight)
  const plot = useEditor((s) => s.project.plot)

  function addFloor() {
    const b = bounds(plot.boundary)
    const sb = plot.setbacks
    const footprint = rectPath(
      b.minX + sb.left,
      b.minY + sb.rear,
      b.maxX - b.minX - sb.left - sb.right,
      b.maxY - b.minY - sb.front - sb.rear,
    )
    const id = nanoid()
    update((d) => {
      const top = d.levels.reduce((m, l) => Math.max(m, l.baseElevation), 0)
      const n = d.levels.length
      d.levels.push({
        id,
        name: ordinalFloorName(n),
        baseElevation: top + floorHeight,
        height: floorHeight,
        footprint,
        spaces: [],
        props: [],
      })
    })
    setActiveLevel(id)
  }

  const sorted = [...levels].sort((a, b) => b.baseElevation - a.baseElevation)

  return (
    <section className="panel level-panel">
      <div className="panel-head">
        <h3>Floors</h3>
        <button className="mini-btn" onClick={addFloor} title="Add floor above">
          +
        </button>
      </div>
      <div className="level-list">
        {sorted.map((lvl) => (
          <div
            key={lvl.id}
            className={`level-row${lvl.id === activeLevelId ? ' active' : ''}`}
          >
            <button className="level-item" onClick={() => setActiveLevel(lvl.id)}>
              <span className="level-name">{lvl.name}</span>
              <span className="level-meta">
                {formatFeetInches(lvl.baseElevation)} · {lvl.spaces.length} spaces
              </span>
            </button>
            <button
              className="mini-btn level-dup"
              onClick={() => duplicateFloor(lvl.id)}
              title="Duplicate this floor above"
            >
              ⧉
            </button>
          </div>
        ))}
      </div>
    </section>
  )
}
